import AppBar from "@material-ui/core/AppBar";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React, { useContext } from "react";
import PerfilTiendaDetails from "../../../components/PerfilTiendaDetails";
import { MobileContext } from "../Mobile";

const drawerWidth = "100vw";

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa"
  },
  backButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  }
}));

const PerfilTienda = () => {
  const classes = useStyles();
  const { perfilTiendaOpen, onClosePerfilTienda } = useContext(MobileContext);

  return (
    <Drawer
      className={classes.drawer}
      open={perfilTiendaOpen}
      anchor="right"
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            className={classes.backButton}
            edge="start"
            color="inherit"
            onClick={onClosePerfilTienda}
          >
            <ArrowBackIcon />
          </IconButton>

          <Typography className={classes.title} variant="h6">
            Perfil de Tienda
          </Typography>
        </Toolbar>
      </AppBar>

      <PerfilTiendaDetails />
    </Drawer>
  );
};

export default PerfilTienda;
